// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__148pV","footer":"ModalFilter_footer__3fHpd"};